import * as Yup from 'yup'
import { PlanType } from '@labrav/react-components'
import { Product } from '../../modules/productsListing/types'
import { isAzureContainerProduct } from '../../components/MicrosoftFormComponent/ContainerPlan/containerPlanUtils'
import { isAzureVmProduct } from '../../components/MicrosoftFormComponent/VmPlan/vmPlanUtils'
import validateMicrosoftPrivateOffer from './validateMicrosoftPrivateOffer'
import validateContainerMicrosoftPrivateOffer from './validateContainerMicrosoftPrivateOffer'
import validateVmMicrosoftPrivateOffer from './validateVmMicrosoftPrivateOffer'

export const getMicrosoftPrivateOfferValidationSchema = (
  isSalesforceContext: boolean,
  product?: Product
): Yup.AnyObjectSchema => {
  if (isAzureContainerProduct(product)) {
    return validateContainerMicrosoftPrivateOffer(isSalesforceContext)
  }

  if (isAzureVmProduct(product)) {
    return validateVmMicrosoftPrivateOffer(isSalesforceContext)
  }

  return validateMicrosoftPrivateOffer(isSalesforceContext)
}

export const getContainerMicrosoftPrivateOfferValidationSchema = (
  isSalesforceContext: boolean
): Yup.AnyObjectSchema =>
  getMicrosoftPrivateOfferValidationSchema(isSalesforceContext, {
    productType: PlanType.CONTAINER,
  } as Product)
